import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useInRouterContext } from 'react-router-dom';
import 'antd/dist/reset.css';
import App from './components/App';
import ErrorBoundary from './components/UI/ErrorBoundary';
import ThemeProvider from './contexts/ThemeContext';
import './bootstrap';

function MaybeRouter({ children }) {
    // If we're already inside a Router, don't create another
    const isInsideRouter = useInRouterContext();
    return isInsideRouter ? children : <BrowserRouter>{children}</BrowserRouter>;
}


const container = document.getElementById('app');
if (container && !container.__reactRoot) {
    container.__reactRoot = ReactDOM.createRoot(container);
    container.__reactRoot.render(
        <React.StrictMode>
            <ErrorBoundary>
                <ThemeProvider>
                    <MaybeRouter>
                        <App />
                    </MaybeRouter>
                </ThemeProvider>
            </ErrorBoundary>
        </React.StrictMode>
    );
}
